<button
  matButton
  [matMenuTriggerFor]="schoolMenu"
  class="flex items-center gap-1.5 px-4 py-1.5 rounded-full text-sm! font-medium text-white/60! hover:text-white! hover:bg-white/10! transition-colors normal-case!"
>
  <mat-icon class="text-white/70 text-[18px]! w-4.5! h-4.5!">school</mat-icon>
  <span>{{ schoolService.selectedSchool()?.name ?? 'Zvolte školu' }}</span>
  <mat-icon class="text-white/50 text-[18px]! w-4.5! h-4.5!">arrow_drop_down</mat-icon>
</button>

<mat-menu #schoolMenu="matMenu" panelClass="min-w-56">
  <div class="px-4 py-2.5 border-b border-black/8 mb-1" (click)="$event.stopPropagation()">
    <p class="text-xs font-medium text-gray-400 uppercase tracking-wider">Zvolit školu</p>
  </div>
  @for (school of schoolService.schools(); track school.id) {
    <button mat-menu-item (click)="schoolService.selectSchool(school.id)">
      <mat-icon
        class="text-primary transition-opacity"
        [class.opacity-0]="school.id !== schoolService.selectedSchool()?.id"
        >check
      </mat-icon>
      <span [class.font-medium]="school.id === schoolService.selectedSchool()?.id">{{
        school.name
      }}</span>
    </button>
  }
</mat-menu>
